module.exports = __webpack_public_path__ + "img/bubble.d577783d.jpg";